import { useSetAtom, useAtom, atom } from 'jotai';

export type DailyActivityPeriod = 'morning' | 'evening';

type DailyActivityModalState = {
  open: boolean;
  period: DailyActivityPeriod | null;
  date: string | null;
  // set only for a trainer viewing a client's shared entry (Daily Activity
  // "shared with trainer" notification) — makes the modal read-only.
  clientId: string | null;
};

const dailyActivityModalAtom = atom<DailyActivityModalState>({
  clientId: null,
  date: null,
  open: false,
  period: null,
});

// Write-only, for callers (the notification-click handler) that must not
// re-render on every state change — same shape as useSetPostExitOffer.
export const useSetDailyActivityModal = () => {
  const setState = useSetAtom(dailyActivityModalAtom);
  return (period: DailyActivityPeriod, date: string, clientId?: string) =>
    setState({ clientId: clientId ?? null, date, open: true, period });
};

// Global (atom + AppLayout host, per usePostExitOfferStore's precedent):
// opened from a notification toast/list item on any page, so a
// locally-rendered modal would die the moment that page's owner unmounts.
export const useDailyActivityModalStore = () => {
  const [state, setState] = useAtom(dailyActivityModalAtom);
  return {
    clientId: state.clientId,
    close: () => setState((prev) => ({ ...prev, open: false })),
    date: state.date,
    isOpen: state.open,
    period: state.period,
  };
};
